export default __webpack_public_path__ + "static/media/IC_chrome_48x48.c3039ff9.png";